<template lang="pug">
  .component-selectize-vehicle
    selectize(v-if="options", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved", placeholder="Parking group", ref="selectize")
</template>

<script>
  import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
  import BaseSelectize from './BaseSelectize'
  import Selectize from '../../../Selectize'

  export default {
    name: 'SelectizeParkingGroup',
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'name',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.parkingGroups.list.all((data) => {
        this.options = data
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div>PG${item.id} ${item.name}</div>`

      },
      renderTemplate(item, escape) {
        return `<div>PG${item.id}<br><small>${item.name}</small></div>`
      },
      optionsLoader() {

      },
      clearSelected() {
        this.$refs.selectize.clearSelected()
      }
    },
    props: ['selectedValue']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeParkingGroup.vue?3a63d767